import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from './tokens';
import { SharedUtilsHelpersModule } from '@ecosure-suite/shared/utils-helpers';
import {
  IdNumberValidatorDirective,
  MsisdnValidatorDirective,
  PersonNameValidatorDirective,
  BurialSocietyNameValidatorDirective
} from './validators';
import {
  ErrorMessage,
  CUSTOM_ERROR_MESSAGES
} from 'ng-bootstrap-form-validation';
import { AddressValidatorDirective } from './validators/address-validator.directive';

// Custom Error Messages
export const CUSTOM_ERRORS: ErrorMessage[] = [
  {
    error: 'personName',
    format: personNameFormat
  },
  {
    error: 'idNumber',
    format: idNumberFormat
  },
  {
    error: 'required',
    format: isRequired
  },
  {
    error: 'burialSocietyName',
    format: burialSocietyNameFormat
  }
];

export function idNumberFormat(label: string, error: any): string {
  return `${label.replace(/( \*)/, '')} is invalid.`;
}

export function personNameFormat(label: string, error: any): string {
  return `${label.replace(/( \*)/, '')} is invalid`;
}

export function isRequired(label: string, error: any): string {
  return `${label.replace(/( \*)/, '')} is required`;
}

export function burialSocietyNameFormat(label: string, error: any): string {
  return `${label.replace(/( \*)/, '')} is invalid`;
}

@NgModule({
  imports: [CommonModule, SharedUtilsHelpersModule],
  declarations: [
    IdNumberValidatorDirective,
    MsisdnValidatorDirective,
    PersonNameValidatorDirective,
    BurialSocietyNameValidatorDirective,
    AddressValidatorDirective
  ],
  exports: [
    IdNumberValidatorDirective,
    MsisdnValidatorDirective,
    PersonNameValidatorDirective,
    BurialSocietyNameValidatorDirective,
    AddressValidatorDirective
  ]
})
export class SharedUtilValidatorsModule {
  static forRoot(configuration: ValidatorsConfiguration): ModuleWithProviders {
    return {
      ngModule: SharedUtilValidatorsModule,
      providers: [
        {
          provide: VALIDATORS_CONFIGURATION_TOKEN,
          useValue: configuration
        },
        {
          provide: CUSTOM_ERROR_MESSAGES,
          useValue: CUSTOM_ERRORS,
          multi: true
        }
      ]
    };
  }
}
